import { useCallback } from 'react';

import { StationsFilter } from 'entities/stations';

import { stationsAPI } from 'entities/stations';

export const useGetFilteredStationCodes = () => {
  const getFilteredStationCodes = useCallback(async (filter: StationsFilter) => {
    try {
      const { data: filteredStationCodes } = await stationsAPI.getFilteredStationCodes(filter);
      return filteredStationCodes;
    } catch (e) {
      return [];
    }
  }, []);

  return getFilteredStationCodes;
};
